export enum OptimizationTypes {
    OFF = 'off',
    CPA = 'cpa',
    CPV = 'cpv',
}
